export const FORM_NAME = 'loginModal'
